<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item :label="'Date'" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-range-picker
                v-model="queryParam.dataDt"
                format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>

          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
<!--              <a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">Export</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowClassName="rowClassName"
        bordered
        @change="handleTableChange">
      </a-table>

    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getFinancialList} from '@/webpublicapi/statistics'
import Dict from '../modules/Dict';
import RefundTradeModal from './modules/RefundTradeModal'
import moment from "moment";
import exportFile from "@/webpublicapi/exportFile";
export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict
  },
  data () {
    return {
      visible: false,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      // Query conditions
      queryParam: {
        dataDt: undefined,
      },
      loading: false,
      // Table header
      columns: [
        {
          title: 'Date',
          align: 'left',
          dataIndex: 'curDate'
        },
        {
          title: 'First Overdue',
          align: 'left',
          dataIndex: 'firstOverdueRate'
        },
        {
          title: 'New Customer First Overdue',
          align: 'left',
          dataIndex: 'newFirstOverdueRate'
        },
        {
          title: 'Old Customer First Overdue',
          align: 'left',
          dataIndex: 'oldFirstOverdueRate'
        },
        {
          title: 'Outstanding Balance',
          align: 'left',
          dataIndex: 'balAmt'
        },
        {
          title: 'Compared to Yesterday Increase',
          align: 'left',
          dataIndex: 'increaseBalAmt'
        },
        {
          title: 'Same Day Loan Amount',
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: 'Disbursement Count',
          align: 'left',
          width: '100px',
          dataIndex: 'paymentCount'
        },
        {
          title: 'New Customer Disbursement Count',
          align: 'left',
          width: '100px',
          dataIndex: 'newPaymentCount'
        },
        {
          title: 'Old Customer Disbursement Count',
          align: 'left',
          width: '100px',
          dataIndex: 'oldPaymentCount'
        },
        {
          title: 'Same Day Repayment Amount',
          align: 'left',
          width: '150px',
          dataIndex: 'repayAmt'
        },
        {
          title: 'Today Profit',
          align: 'left',
          width: '150px',
          dataIndex: 'profitAmount'
        },


        {
          title: 'Same Day Due Period Count',
          align: 'left',
          dataIndex: 'remarks'
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getFinancialList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows

          for(var i = 0; i < this.dataSource.length ; i ++){
            this.dataSource[i].firstOverdueRate = (this.dataSource[i].firstOverdueRate * 100).toFixed(2);
            this.dataSource[i].newFirstOverdueRate = (this.dataSource[i].newFirstOverdueRate * 100).toFixed(2);
            this.dataSource[i].oldFirstOverdueRate = (this.dataSource[i].oldFirstOverdueRate * 100).toFixed(2);

            this.dataSource[i].profitAmount = (this.dataSource[i].repayAmt - this.dataSource[i].paymentAmt).toFixed(2);
          }

        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams () {
      const { dataDt } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
        installmentType: "1",
      }
      delete data.dataDt;
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd () {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = 'Add new'
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    rowClassName(record,index){
      const date = new Date(record.curDate)
      let className= date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
      return className;
    }
    // downLoadData (arg2) {
    //   var params = this.getQueryParams(arg2)// Query conditions
    //   const file = {
    //     fileUrl: '/api/web/statistics/appAllCountForDateExcel?startDate=' + params.startDate + '&endDate=' + params.endDate,
    //     fileName: 'appAllCountExcel.xls',
    //   }
    //   this.loading = true;
    //   exportFile(file).catch(e => {
    //     this.$message.error(e.message);
    //   }).finally(() => {
    //     this.loading = false;
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
